import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import routeTable from '../../../utility/routeTable';
import { AuctionsListComponent } from './auctions-list/auctions-list.component';
import { AuctionRegisterationComponent } from './auction-registeration/auction-registeration.component';
import { AuctionLotCatalogComponent } from './auction-lot-catalog/auction-lot-catalog.component';
import { EnquiryNowComponent } from './enquiry-now/enquiry-now.component';
import { ViewLotComponent } from './view-lot/view-lot.component';
import { AuctionDetailsComponent } from '../../shared/component/auction-details/auction-details.component';
import { AuctionStatusResolver } from './auction-status-resolver.service';

const routes: Routes = [
  {
    path: routeTable.public.currentAuction,
    component: AuctionsListComponent,
    data: { title: 'Current Auctions', type: 'CurrentAuction' },
  },
  {
    path: routeTable.public.pastAuction,
    component: AuctionsListComponent,
    data: { title: 'Recent Auctions', type: 'PastAuction' },
  },
  {
    path: routeTable.public.turnKeySale,
    component: AuctionsListComponent,
    data: { title: 'Past Turn Key Sales', type: 'TurnKeySale' },
  },
  {
    path: routeTable.public.machinery,
    component: AuctionsListComponent,
    data: { title: 'Industrial Surplus', type: 'Machinery' },
  },
  {
    path: routeTable.public.featuredPast,
    component: AuctionsListComponent,
    data: { title: 'Featured Past Auctions', type: 'FeaturedPast' },
  },
  {
    path: routeTable.public.publicLink,
    resolve: {
      auctionState: AuctionStatusResolver,
    },
    children: [
      {
        path: '',
        component: AuctionDetailsComponent,
      },
      {
        path: routeTable.public.auctionRegister,
        component: AuctionRegisterationComponent,
      },
      {
        path: routeTable.public.auctionLot,
        data: { lowConnectionNeeded: true },
        children: [
          {
            path: '',
            component: AuctionLotCatalogComponent,
          },
          {
            path: routeTable.public.viewAuctionLotDetail,
            component: ViewLotComponent,
          },
        ],
      },
      {
        path: routeTable.public.enquire,
        component: EnquiryNowComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuctionRoutingModule {}
